export const updateWindowSize = (windowSize) => ({
  type: 'UPDATE_WINDOW_SIZE',
  windowSize
});



// WEBPACK FOOTER //
// ./src/actions/window-size.js